<template>
  <div class="recruit">
    <customer-header />
    <div class="top-padding">
      <div class="cs-body">
        <div class="policy-wrap">
          <div class="policy-content">
            <h2 class="policy-tit">MNO 회원가입 동의</h2>
            <div class="policy-desc" id="policy-desc">
              <div>
                <h3>개인정보의 수집 및 이용 (필수)</h3>
                <table>
                  <caption>개인정보의 수집 및 이용 표</caption>
                  <colgroup>
                    <col style="width: 50%">
                    <col style="width: 20%">
                    <col style="width: 30%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>목적</th>
                      <th>항목</th>
                      <th>기간</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>SK텔레콤x웨이브 결합 상품 중 MNO 부가서비스 이용권 등록 가능여부 확인
                      </td>
                      <td>휴대폰 번호</td>
                      <td>
                        <span class="emphasis">제공 및 가입여부 확인, 고객 불편방지, 민원처리, 분쟁해결 등을 위하여 6개월간 보유</span></td>
                    </tr>
                  </tbody>
                </table>
                <p>* 미동의시 MNO 부가서비스 이용권 등록이 불가합니다.</p>
              </div>
              <div>
                <h3>개인정보의 제3자 제공 (필수)</h3>
                <table>
                  <caption>개인정보의 제3자 제공 표</caption>
                  <colgroup>
                    <col style="width: 25%">
                    <col style="width: 25%">
                    <col style="width: 20%">
                    <col style="width: 30%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>제공받는 자</th>
                      <th>목적</th>
                      <th>항목</th>
                      <th>기간</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span class="emphasis">SK텔레콤(주)</span>
                      </td>
                      <td>
                        <span class="emphasis">SK텔레콤x웨이브 결합 상품 중 MNO 부가서비스 이용권 등록 가능 여부 확인</span>
                      </td>
                      <td>휴대폰 번호</td>
                      <td>
                        <span class="emphasis">회원가입 가능여부만 확인하며 별도 저장하지 않음</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p>* 미동의시 MNO 부가서비스 이용권 등록이 불가합니다.</p>
              </div>
              <p>* 본인은 개인정보 수집 및 이용, 제3자 제공과 관련한 위의 내용을 확인하였으며 동의합니다.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import CustomerHeader from '@/components/common/header/CustomerHeader'

  export default {
    name: 'sign_up_agreement',
    components: { CustomerHeader }
}
</script>
<style lang="scss" src="@/assets/scss/category/service.scss"></style>
